module.exports = __webpack_public_path__ + "static/waterfall_dark-399b1756f19811c8addb5ef8c1de1ade.gif";